import { atom } from "jotai";

import _ from "lodash";

interface IPublishState {
  lastpublish: string | null;
  lastchange: string | null;
}

const examplePublishAtom = atom<IPublishState>({
  lastpublish: null,
  lastchange: null,
});

const changesSchema = JSON.stringify({
  lastchange: "string",
  lastpublish: "string",
});

const publishProfileNodeAtom = atom<IPublishState>({
  lastpublish: null,
  lastchange: null,
});

const publishContentNodeAtom = atom<IPublishState>({
  lastpublish: null,
  lastchange: null,
});

const publishVideoNodeAtom = atom<IPublishState>({
  lastpublish: null,
  lastchange: null,
});

const publishAttractorAtom = atom<IPublishState>({
  lastpublish: null,
  lastchange: null,
});

export {
  examplePublishAtom,
  changesSchema,
  publishProfileNodeAtom,
  publishContentNodeAtom,
  publishVideoNodeAtom,
  publishAttractorAtom,
};
export type { IPublishState };
